class window.ToggleBlock
  constructor: ->
    @initToggleBlock()

  initToggleBlock: ->
    $('.toggle-block__head').click ->
      $(this).toggleClass('toggle-block__head--active');
      $(this).parent('.toggle-block').find('.toggle-block__content').slideToggle()


// WEBPACK FOOTER //
// ./assets/javascripts/app/toggle_block.coffee